import {
    SOLICITO_INFORMACION_PACIENTE,
    SOLICITO_INFORMACION_PACIENTE_EXITO,
    SOLICITO_INFORMACION_PACIENTE_ERROR,
    ACTUALIZAR_INFORMACION_PACIENTE_EXITO,
    ACTUALIZAR_INFORMACION_PACIENTE_ERROR,

    CAMBIAR_ARCHIVADO_PACIENTE_SOLICITO,
    CAMBIAR_ARCHIVADO_PACIENTE_EXITO,
    CAMBIAR_ARCHIVADO_PACIENTE_ERROR

} from '../types';
import clienteAxios from '../config/axios';

/* Solicito datos de la DB */
export function cargarPacientesAction(informacion) {
    return async (dispatch) => {
        dispatch (solicitoInformacion());
        try {
            const {config} = informacion;
            const respuesta = await clienteAxios.get('/paciente/buscarpacientes',config);
            dispatch( solicitoInformacionExito(respuesta.data.informacion));
        } catch (error) {
            const errores = error.response;
            if (errores !== undefined) {
                dispatch( solicitoInformacionError(error.response.data) );
            }
        }
    }
}

const solicitoInformacion = () => ({
    type: SOLICITO_INFORMACION_PACIENTE,
    payload: true
});

// si logro obtener la informacion de la BD
const solicitoInformacionExito = (data) => ({
    type: SOLICITO_INFORMACION_PACIENTE_EXITO,
    payload: data
});

// si hubo un error
const solicitoInformacionError = (msg) => ({
    type: SOLICITO_INFORMACION_PACIENTE_ERROR,
    payload: msg
});

export function actualizarPacientesAction(informacion) {
    return async (dispatch) => {
        try {
            dispatch( actualizoInformacionExito({lista_pacientes: informacion}));
        } catch (error) {
            dispatch( actualizoInformacionError('Hubo un error') );
        }
    }
}


const actualizoInformacionExito = (data) => ({
    type: ACTUALIZAR_INFORMACION_PACIENTE_EXITO,
    payload: data
});

// si hubo un error
const actualizoInformacionError = (msg) => ({
    type: ACTUALIZAR_INFORMACION_PACIENTE_ERROR,
    payload: msg
});

export function cambiarArchivadoPacienteAction(informacion) {

    return async (dispatch) => {

        dispatch(cambiarArchivadoSolicito());

        try {

            const {
                id_paciente,
                archivado,
                config
            } = informacion;


            const respuesta = await clienteAxios.post(
                '/paciente/cambiararchivadopaciente',
                {
                    id_paciente,
                    archivado
                },
                config
            );


            dispatch(
                cambiarArchivadoExito(
                    respuesta.data.paciente
                )
            );


            return {
                ok: true,
                paciente: respuesta.data.paciente
            };


        } catch (error) {

            const mensaje =
                error.response?.data ||
                {
                    msg: 'No se pudo modificar el paciente'
                };


            dispatch(
                cambiarArchivadoError(mensaje)
            );


            return {
                ok: false,
                error: mensaje
            };
        }
    };
}


const cambiarArchivadoSolicito = () => ({
    type: CAMBIAR_ARCHIVADO_PACIENTE_SOLICITO,
    payload: true
});


const cambiarArchivadoExito = (data) => ({
    type: CAMBIAR_ARCHIVADO_PACIENTE_EXITO,
    payload: data
});


const cambiarArchivadoError = (msg) => ({
    type: CAMBIAR_ARCHIVADO_PACIENTE_ERROR,
    payload: msg
});